import { DropdownOption } from 'components/dropdown/component'
import * as Validation from 'components/validation/validations'
import { RasaContext } from 'context'
import { Dataset } from 'generic/dataset'
import { RasaReactComponent } from 'generic/rasaReactComponent'
import React from 'react'
import * as GenerativeAI from 'shared_server_client/types/generative_ai'
import './_styles.scss'
import { getCurrentPlanMaxSources } from '../../../shared_server_client/types/billing_plan'
import {PaperPlaneIcon} from "../../icons/paper-plane";
import { streamChatResponse } from './data'
import { AiAssistant } from 'components/icons/aiAssistant'
import { Loading } from 'components/loading'
import { DEFAULT_PROMPTS, Prompt } from './constants'
import { tryParseJSON } from 'generic/utility'
import { Badge } from 'reactstrap'
import { DashboardMenuOption } from 'components/dashboard-menu/constants'
import * as Constants from './constants'

const ModelTypeOptions: DropdownOption[] = [
  { description: 'default', key: '' },
  { description: 'mistral-tiny', key: 'mistral|mistral-tiny' },
  { description: 'mistral-small', key: 'mistral|mistral-small' },
  { description: 'openai-3.5', key: 'openai|gpt-3.5-turbo' },
  { description: 'openai-4.0', key: 'openai|gpt-4-1106-preview' },
]

interface State {
  categories: GenerativeAI.Keyword[],
  chatInputPlaceholder: string,
  community: string,
  error?: string,
  found: boolean,
  input: string,
  isLoading: boolean,
  message: string,
  topics: string[],
  summary: string,
  showDefaultPrompt: boolean,
  showStreamLoader: boolean,
  streamMessage: string,
  canAddSuggestedSources: boolean,
  model: DropdownOption,
  prompts: GenerativeAI.ChatPrompt[],
  summaryJson: string,
}

const newState: State = {
  categories: [],
  chatInputPlaceholder: '',
  community: '',
  found: true,
  isLoading: false,
  input: '',
  message: '',
  topics: [],
  summary: '',
  summaryJson: '',
  showDefaultPrompt: true,
  showStreamLoader: false,
  streamMessage: '',
  canAddSuggestedSources: false,
  model: ModelTypeOptions[0],
  prompts: [],
}

export class AnalyzeContentComponentClass extends RasaReactComponent<any, State> {
  public chatEndRef;
  public chatInputRef;
  public static contextType = RasaContext;
  constructor(props: any) {
    super(props, 'communitySource', newState)
    this.sendMessage = this.sendMessage.bind(this)
    this.handleOnEnter = this.handleOnEnter.bind(this)
    this.chatEndRef = React.createRef()
    this.chatInputRef = React.createRef()
  }

  public componentDidMount = () => {
    this.context.user.init().then(({person, activeCommunity}) => {
      const maxAllowedSources = getCurrentPlanMaxSources(activeCommunity.billingInfo.currentPlan)
      this.loadRecord(activeCommunity.communityId, null)
      new Dataset()
        .loadCommunityDataset('communitySources', activeCommunity.communityId)
        .then((response) => {
          const sources = response[0] || []
          const activeSources = sources.filter((s) => !!s.is_active && s.source_type !== 'Manual Entry')
            .sort((s1, s2) => s2.last_week_total - s1.last_week_total)
          this.setState({
            community: activeCommunity.communityId,
            canAddSuggestedSources: maxAllowedSources > activeSources.length
          })
        })
    })
  }

  public render = () => {
    return (
      <div className="rex-wrapper">
        <div className="rex-wrapper_scroll" ref={this.chatEndRef}>
          <h1 className="rex-wrapper_heading"><AiAssistant svgwidth="50" svgheight="50" />Rex</h1>
          <h1 className="rex-wrapper_heading">Try asking me questions like:</h1>
          <div className="rex-wrapper_list-msg">
            {this.state.showDefaultPrompt ? DEFAULT_PROMPTS.map((prompt, index) => {
              return (
                <div key={index} className='rex-wrapper-chat-item'>
                  <button onClick={() => this.executeDefaultPrompt(prompt)} className="rex-wrapper_btn-list">{prompt.content}</button>
                </div>
              )
            }): null}
            {
              this.state.prompts.map((prompt, index) => {
                const jsonContent = tryParseJSON(prompt.content)
                return (
                  <div key={index} className='rex-wrapper-chat-item'>
                    {prompt.role === 'user' ? <i className="rex-wrapper_img-list fa-user fa"></i> :
                    <i className="rex-wrapper_img-list"><AiAssistant svgwidth="30" svgheight="30" /></i>}
                    <div className="rex-wrapper_msg-list">
                      <p>
                        {jsonContent.summary ? 
                        <div>
                          <div className="summary">
                            <h2>Summary</h2>
                            <span>{jsonContent.summary}</span>
                          </div>
                          { jsonContent.topics.length > 0 &&
                          <div>
                            <div className="summary">
                              <h3>Topics</h3>
                              <span>Topics related to this URL</span>
                            </div>
                            <div className="keywords">
                              {jsonContent.topics.split(',').map((k: string, topicIndex: number) => (
                                <Badge className="keyword" key={`keyword-${topicIndex}`}
                                        onClick={(e) => this.removeTopic(topicIndex)}>
                                  <span>{k}</span>
                                  <span className="badge-close">x</span>
                                </Badge>)) }
                            </div>
                          </div>}
                        </div> : prompt.content
                        }
                      </p>
                    </div>
                  </div>
                )
              })
            }
            {this.state.streamMessage ?
            <div className='rex-wrapper-chat-item'>
              <i className="rex-wrapper_img-list">
                <AiAssistant svgwidth="30" svgheight="30" />
              </i>
              <div className="rex-wrapper_msg-list">
                <p>
                  {this.state.streamMessage}
                </p>
              </div>
            </div> : null}
            {this.state.summary ?
              <div className='rex-wrapper-chat-item rex-chat-loader'>
                <i className="rex-wrapper_img-list">
                  <AiAssistant svgwidth="30" svgheight="30" />
                </i>
                <div className="rex-wrapper_msg-list">
                  <div className='rex-wrapper-chat-item'>
                    <h3>Choose an action</h3>
                  </div>
                  <div className='rex-wrapper-chat-item'>
                    <button onClick={this.suggestContent} className="rex-prompt-btn">Suggest content based on the given summary & topics</button>
                  </div>
                  <div className='rex-wrapper-chat-item'>
                    <button onClick={this.exploreMore} className="rex-prompt-btn">{Constants.EXPLORE_MORE_PROMPT.content}</button>
                  </div>
                </div>
              </div>: null}
          </div>
        </div>
        {this.state.showStreamLoader ?
          <div className='rex-wrapper-chat-item rex-chat-loader'>
            <i className="rex-wrapper_img-list">
              <AiAssistant svgwidth="30" svgheight="30" />
            </i>
            <div className="rex-wrapper_msg-list">
              <p>
                <Loading size="16"></Loading>
              </p>
            </div>
          </div> : null}
        <div className="rex-wrapper_form-wrapper">
          <form action="#">
            <input type="text" ref={this.chatInputRef} onKeyDown={this.handleOnEnter} value={this.state.message} onChange={(e) => this.setState({message: e.target.value}) } 
              placeholder={this.state.chatInputPlaceholder} className="rex-wrapper_form-input"/>
            <button className="rex-wrapper_form-btn-submit">
              <PaperPlaneIcon onClick={this.sendMessage}/>
            </button>
          </form>
        </div>
      </div>
    )
  }

  private suggestContent = () => {
    //do something
    const queryString = [
      `topics=${this.state.topics.join(',')}`,
      `summary=${this.state.summary}`,
    ].join('&')
    window.location.href = `${DashboardMenuOption.content}/${Constants.SUGGEST_ARTICLES_PAGE}?${queryString}`
  }

  private exploreMore = () => {
    this.setState({
      summary: '',
      topics: [],
    })
    this.executeDefaultPrompt(Constants.EXPLORE_MORE_PROMPT)
  }

  private removeTopic = (index: number) => {
    if ( index >= 0 && index < this.state.topics.length) {
      const newTopics = [...this.state.topics]
      newTopics.splice(index, 1)
      this.setState({
        topics: newTopics,
      })
    }
  }

  private scrollToBottom = () => {
    this.chatEndRef.current.scrollTop = this.chatEndRef.current.scrollHeight;
  }

  protected validInput(): boolean {
    return Validation.validateForgivingUrl(this.state.input).valid || Validation.validateDomain(this.state.input).valid
  }

  protected handleOnEnter(e) {
    if (e.key === 'Enter') {
      e.preventDefault()
      this.sendMessage()
    }
  }
  protected sendMessage = (message: string = "") => {
    this.setState({
      prompts: 
        [
          ...this.state.prompts,
          {
            role: 'user',
            content: message ? message : this.state.message,
          }
        ],
      message: '',
      showStreamLoader: true,
      showDefaultPrompt: false,
      chatInputPlaceholder: '',
    }, () => {
      streamChatResponse(this.state.community, this.state.prompts, this.updateChatMessage)
      this.scrollToBottom()
    })
  }

  private executeDefaultPrompt = (prompt: Prompt) => {
    // if prompt has some placeholder it means it requires user's input
    if (prompt.placeholder) {
      this.setState({
        prompts: 
        [
          ...this.state.prompts,
          {
            role: 'user',
            content: prompt.content,
          }
        ],
        chatInputPlaceholder: prompt.placeholder,
        showDefaultPrompt: false,
      })
      this.chatInputRef.current.focus()
    } else {
      this.setState({
        showDefaultPrompt: false,
      })
      this.sendMessage(prompt.content)
    }
  }

  private updateChatMessage: GenerativeAI.ChatCallback = (response: GenerativeAI.ChatResponse) => {
    if ( !response ) {
      this.setState({
        isSaving: false,
      })
    } else {
      if ( response.done || response.error ) {
        if (this.state.summaryJson) {
          const jsonString = this.state.summaryJson + response.message
          const summaryJson = tryParseJSON(jsonString)
          if (summaryJson) {
            this.setState({
              prompts: [
                ...this.state.prompts,
                {
                  role: 'assistant',
                  content: jsonString,
                }
              ],
              summaryJson: '',
              summary: summaryJson.summary,
              topics: summaryJson.topics ? summaryJson.topics.split(',') : [],
              showStreamLoader: false,
            })
          }
        } else {
          this.setState({
            prompts: [
              ...this.state.prompts,
              {
                role: 'assistant',
                content: this.state.streamMessage,
              }
            ],
          })
        }
        this.setState({
          isSaving: false,
          error: response.error,
          streamMessage: '',
          showStreamLoader: false,
        })
      } else {
        if ( response.message ) {
          if (response.message.startsWith('{') || this.state.summaryJson) {
            this.setState({
              summaryJson: this.state.summaryJson + response.message,
              showStreamLoader: false,
            })
          } else {
            this.setState({
              streamMessage: this.state.streamMessage + response.message,
              showStreamLoader: false,
            })
          }
        }
      }
      this.scrollToBottom()
    }
  }

}
